import React from 'react';

export const ReactNexusTalkPage: React.FC = () => (
  <iframe
    src="/reactnexustalk.html"
    title="Pixel Machha Talk — React Nexus"
    style={{ width: '100vw', height: '100vh', border: 'none', position: 'fixed', inset: 0, zIndex: 9999 }}
  />
);
